/**
 * Production Orders - Shared Utilities
 *
 * Common formatting and helper functions used across production order components.
 */

/**
 * Format a timestamp as relative time (e.g., "6h ago", "2d ago")
 *
 * Used in:
 * - BatchPreview (order age range)
 * - PapReminderBanner (oldest P&P order age)
 * - OrderSelectionList (order age column) - uses date-fns but could migrate
 *
 * Note: This is a lightweight alternative to date-fns's formatDistanceToNow
 * for cases where we want shorter, more compact output.
 */
export function formatRelativeTime(isoTimestamp: string): string {
  if (!isoTimestamp) return 'unknown';
  const date = new Date(isoTimestamp);
  const now = Date.now();
  const diffMs = now - date.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes < 1) return 'just now';
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays}d ago`;
}
